import { render, staticRenderFns } from "./TenderAgency.vue?vue&type=template&id=6675ee70&"
import script from "./TenderAgency.vue?vue&type=script&lang=js&"
export * from "./TenderAgency.vue?vue&type=script&lang=js&"
import style0 from "./TenderAgency.vue?vue&type=style&index=0&id=6675ee70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports